// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  COMPRA_USADOS_CLEAN_CARD_FORM,
} from './constants';
import initialState from './initialState';

export function cleanCardForm() {
  return {
    type: COMPRA_USADOS_CLEAN_CARD_FORM,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COMPRA_USADOS_CLEAN_CARD_FORM:
      return {
        ...state,
        ...initialState
      };

    default:
      return state;
  }
}
